export const sanitizeField = (
  value,
  type
) => {
  switch (type) {
    case "ALPHABET":
      return value.replace(
        /[^A-Za-z\s]/g,
        ""
      );

    case "ALPHANUMERIC":
      return value.replace(
        /[^a-zA-Z0-9\s&.,'-]/g,
        ""
      );

    case "NUMBER":
      return value.replace(
        /[^\d]/g,
        ""
      );

    case "PHONE":
      return value
        .replace(/[^\d]/g, "")
        .slice(0, 10);

    case "EMAIL":
      return value
        .trim()
        .toLowerCase();

    default:
      return value;
  }
};